module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "chat-admin-page"
  }, [_c('div', {
    staticClass: "admin-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "admin-stats"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalRooms))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Conversas")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.totalMessages))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Mensagens")])])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-body",
    class: {
      'room-selected': !!_vm.selectedRoom
    }
  }, [_c('div', {
    staticClass: "rooms-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h2', [_vm._v("Conversas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "Buscar conversa/usuário..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.searchRooms]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Carregando...")]) : _c('div', {
    staticClass: "rooms-list"
  }, [_vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "room-card",
      class: {
        active: _vm.selectedRoom && _vm.selectedRoom.id === room.id
      },
      on: {
        "click": function($event) {
          return _vm.selectRoom(room)
        }
      }
    }, [_c('div', {
      staticClass: "room-avatar"
    }, [_vm._v("\n                " + _vm._s(_vm.getRoomInitial(room)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "room-info"
    }, [_c('div', {
      staticClass: "room-top"
    }, [_c('div', {
      staticClass: "room-name"
    }, [_vm._v(_vm._s(room.name || ('Conversa #' + room.id)))])]), _vm._v(" "), _c('div', {
      staticClass: "room-users"
    }, [_vm._v("\n                  " + _vm._s(_vm.getRoomUsers(room)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "room-last"
    }, [_vm._v("\n                  " + _vm._s(_vm.getRoomLastMessage(room)) + "\n                ")])])])
  }), _vm._v(" "), (_vm.rooms.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("Nenhuma conversa")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "messages-panel"
  }, [(!_vm.selectedRoom) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "messages-view"
  }, [_c('div', {
    staticClass: "messages-header"
  }, [_c('div', {
    staticClass: "messages-header-left"
  }, [_c('button', {
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.selectedRoom = null
      }
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v(_vm._s(_vm.selectedRoom.name || ('Conversa #' + _vm.selectedRoom.id)))]), _vm._v(" "), _c('div', {
    staticClass: "selected-room-users"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRoomUsers(_vm.selectedRoom)) + "\n                  ")])])]), _vm._v(" "), _c('button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportMessages
    }
  }, [_vm._v("Exportar")])]), _vm._v(" "), _c('div', {
    ref: "messagesContainer",
    staticClass: "messages-container"
  }, [(_vm.loadingMessages) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("Carregando...")]) : _c('div', [_vm._l((_vm.messages), function(msg) {
    return _c('div', {
      key: msg.id,
      staticClass: "message-item"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('div', {
      staticClass: "sender-avatar"
    }, [_vm._v("\n                      " + _vm._s(_vm.getSenderInitial(msg)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "sender-info"
    }, [_c('strong', [_vm._v(_vm._s(_vm.getSenderName(msg)))]), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(_vm.formatDateTime(msg.timestamp)))])])]), _vm._v(" "), _c('div', {
      staticClass: "message-body"
    }, [(_vm.hasFiles(msg)) ? _c('div', {
      staticClass: "files-wrap"
    }, _vm._l((msg.files), function(file) {
      return _c('div', {
        key: file.id || file.url,
        staticClass: "file-item"
      }, [(_vm.isImage(file)) ? _c('a', {
        staticClass: "image-link",
        attrs: {
          "href": file.url,
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      }, [_c('img', {
        staticClass: "message-image",
        attrs: {
          "src": file.url,
          "alt": file.name || 'imagem'
        }
      })]) : _c('a', {
        staticClass: "file-link",
        attrs: {
          "href": file.url,
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      }, [_c('div', {
        staticClass: "file-icon"
      }, [_vm._v("📎")]), _vm._v(" "), _c('div', {
        staticClass: "file-info"
      }, [_c('div', {
        staticClass: "file-name"
      }, [_vm._v(_vm._s(file.name || 'arquivo'))]), _vm._v(" "), _c('div', {
        staticClass: "file-size"
      }, [_vm._v(_vm._s(_vm.prettySize(file.size)))])])])])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.getMessageText(msg)) ? _c('div', {
      staticClass: "message-content"
    }, [_vm._v("\n                      " + _vm._s(_vm.getMessageText(msg)) + "\n                    ")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.messages.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("Nenhuma mensagem")]) : _vm._e()], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Painel de Chat - MASTER")]), _vm._v(" "), _c('p', {
    staticClass: "admin-subtitle"
  }, [_vm._v("Acompanhe conversas, mídias e histórico em tempo real.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-inner"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("💬")]), _vm._v(" "), _c('p', [_vm._v("Selecione uma conversa")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3227b7a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatAdmin.vue
// module id = 1774
// module chunks = 18